import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  Accordion as ReactAccordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';
import '../../../../../javascripts/shims/findIndex';
import SvgSprite from '../../../../atoms/svg-sprite/SvgSprite.jsx';
import trackEvent from '../../../../../javascripts/helpers/trackEvent';

const Accordion = ({ sections, activeFilter }) => {
  const [expanededItems, updateExpanedItems] = useState([]);

  const trackExpandedItems = items => {
    if (items.length > expanededItems.length) {
      trackEvent('FAQ_Overview_Expand', 'Expand', sections[items.length - 1].title);
    }
    updateExpanedItems(items);
  };

  return (
    <ReactAccordion allowMultipleExpanded allowZeroExpanded onChange={e => trackExpandedItems(e)}>
      {sections.map(
        (section, index) =>
          (activeFilter.some(filter => section.tags.indexOf(filter.slug) !== -1) ||
            activeFilter.length === 0) && (
            <AccordionItem key={section.id || index}>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <div className="accordion__title-wrapper">
                    <h2 className="a-headline a-headline--sub">{section.title}</h2>
                    <SvgSprite
                      id="default-arrow-down"
                      title="ArrowDown"
                      className="accordion__icon"
                    />
                  </div>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {/* eslint-disable-next-line react/no-danger */}
                <div className="m-mixed-copy" dangerouslySetInnerHTML={{ __html: section.text }} />
                {section.href && (
                  <a
                    href={section.href}
                    title={section.title}
                    className="a-link a-link--hover-petrol"
                    onClick={() => trackEvent('FAQ_Overview_Question', section.href)}
                    onKeyDown={e =>
                      e.key.toLowerCase() === 'enter'
                        ? trackEvent('FAQ_Overview_Question', section.href)
                        : null
                    }
                  >
                    <SvgSprite
                      id="default-arrow-small"
                      title="ArrowSmall"
                      className="a-link__icon"
                    />
                    {section.linkLabel}
                  </a>
                )}
              </AccordionItemPanel>
            </AccordionItem>
          )
      )}
    </ReactAccordion>
  );
};

Accordion.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      tags: PropTypes.arrayOf(PropTypes.string).isRequired,
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    })
  ).isRequired,
  activeFilter: PropTypes.arrayOf(PropTypes.shape())
};

Accordion.defaultProps = {
  activeFilter: []
};

export default Accordion;
